import { render, staticRenderFns } from "./CheckinSkeleton.vue?vue&type=template&id=7120fdc8&scoped=true"
import script from "./CheckinSkeleton.vue?vue&type=script&lang=js"
export * from "./CheckinSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120fdc8",
  null
  
)

export default component.exports